import React from "react";

const FamilySectionTitle = ({ children }) => (
  <h2 className="mt-8 px-1 text-[0.82rem] font-black uppercase tracking-[0.16em] text-slate-500">
    {children}
  </h2>
);

export default FamilySectionTitle;
